import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import { getRequest } from "services/api";
// import { buildQueryString } from "utils/queryHelpers";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/label";

  // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    email: "",
    whatsapp: "",
    color: "#000000", // Default color (black)
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "labels"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "labels"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Gunakan hook untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // Jika data produk berubah (untuk update), isi ulang form data
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Label Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Label Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Label Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>

        {/* Color Picker */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="color"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Color:
          </label>
          <div className="col-sm-8">
            <input
              type="color"
              className="form-control"
              id="color"
              name="color"
              value={formData.color}
              onChange={handleChange}
              disabled={isSubmitting}
            />
            {/* Display the selected color code */}
            <div className="mt-2" style={{ fontSize: "14px", color: formData.color }}>
              Selected Color: {formData.color}
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="form-group mt-auto d-grid">
          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={isSubmitting}
          >
            {isUpdateMode ? "Update Label" : "Create Label"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreatePage;
